import { makeAutoObservable, runInAction } from "mobx";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

const NOTIFICATION_TYPES = ["listing", "award_level", "celebration", "license"];

const LIST_NOTIFICATIONS_QUERY = `
  query ListNotificationByGsiHashAndCreatedAt(
    $gsiHash: String!
    $filter: ModelNotificationFilterInput
  ) {
    listNotificationByGsiHashAndCreatedAt(
      gsiHash: $gsiHash
      filter: $filter
    ) {
      items {
        id
        isRead
      }
    }
  }
`;

class NotificationsStore {
  hasUnread = false;
  _endpoint = null;

  constructor() {
    makeAutoObservable(this);
  }

  configure(endpoint) {
    this._endpoint = endpoint;
  }

  async fetchNotifications(userId) {
    const evaToken = getCookie("evaToken");
    if (!evaToken || !userId || !this._endpoint) return;

    try {
      const results = await Promise.all(
        NOTIFICATION_TYPES.map((type) =>
          fetch(this._endpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: evaToken,
            },
            body: JSON.stringify({
              query: LIST_NOTIFICATIONS_QUERY,
              variables: {
                gsiHash: `${userId.toLowerCase()}#talent#${type}`,
                filter: { isCleared: { eq: false } },
              },
            }),
          }).then((res) => res.json()),
        ),
      );
      runInAction(() => {
        this.hasUnread = results.some((result) =>
          result?.data?.listNotificationByGsiHashAndCreatedAt?.items?.some(
            (item) => !item.isRead,
          ),
        );
      });
    } catch (error) {
      console.error("Failed to fetch notifications:", error);
    }
  }
}

export const notificationsStore = new NotificationsStore();
